import Cookies from "js-cookie";
import Choices from "choices.js";
import SwipeListener from "swipe-listener";

const TemplateCompare = {
  scrollInterval: null,
  lastDiff: 0,
  scrolled: 0,
  coookieName: "_cab_compare",

  init() {
    this.create();
    this.scroll();
    this.events();
    this.adjustMaxWidth();

    this.headFix();
    $(window).on("scroll", function () {
      TemplateCompare.headFix();
    });
  },

  create() {
    const addNewMachineryEl = $('[name="new-machinery-select"]');
    if (0 == addNewMachineryEl.length) {
      return;
    }

    new Choices(addNewMachineryEl[0], {
      itemSelectText: "",
      searchEnabled: false,
    });
  },

  headFix() {
    const headEl = $(".compare-table__header");
    const scrolled = $(window).scrollTop();

    const offsetTop = $(".compare-table").offset().top;

    if (scrolled > offsetTop) {
      headEl.show();
    } else {
      headEl.hide();
    }
  },

  scroll() {
    if (window.innerWidth > 768) {
      $(".compare-group__head").css({
        width: "unset",
      });
      return;
    }

    $(".compare-group__head").css({
      width: $(".compare-table").width(),
    });
    $(window).on("resize", function () {
      $(".compare-group__head").css({
        width: $(".compare-table").width(),
      });
    });

    let wrapperEl = $(".compare");
    let container = wrapperEl.find(".compare-table");
    let listener = SwipeListener(wrapperEl[0]);

    let maxScrollX =
      container.data("count") > 1
        ? container.data("count") * 270 - window.innerWidth
        : 0;

    wrapperEl.on("swiping", function (e) {
      clearInterval(TemplateCompare.scrollInterval);

      let diff = e.detail.x[1] - e.detail.x[0];

      let newDiff = diff - TemplateCompare.lastDiff;
      TemplateCompare.lastDiff = diff;

      let newScroll = TemplateCompare.scrolled - newDiff;

      TemplateCompare.scrolled = newScroll;

      TemplateCompare.scrollSet(container);
    });

    wrapperEl.on("swiperelease", function (e) {
      TemplateCompare.lastDiff = 0;
      let outOfBounds = false;

      if (
        TemplateCompare.scrolled < 0 ||
        TemplateCompare.scrolled > maxScrollX
      ) {
        outOfBounds = true;
      }

      if (!outOfBounds) {
        return;
      }

      if (TemplateCompare.scrolled > maxScrollX) {
        TemplateCompare.scrollInterval = setInterval(function () {
          let offset = 5;
          if (TemplateCompare.scrolled > maxScrollX + 300) {
            offset = 30;
          } else if (TemplateCompare.scrolled > maxScrollX + 150) {
            offset = 15;
          }

          TemplateCompare.scrolled = TemplateCompare.scrolled - offset;

          TemplateCompare.scrollSet(container);

          if (TemplateCompare.scrolled <= maxScrollX) {
            clearInterval(TemplateCompare.scrollInterval);
          }
        }, 1);
      } else if (TemplateCompare.scrolled < 0) {
        TemplateCompare.scrollInterval = setInterval(function () {
          let offset = 5;
          if (TemplateCompare.scrolled < -300) {
            offset = 30;
          } else if (TemplateCompare.scrolled < -150) {
            offset = 15;
          }

          TemplateCompare.scrolled = TemplateCompare.scrolled + offset;

          TemplateCompare.scrollSet(container);

          if (TemplateCompare.scrolled >= 0) {
            clearInterval(TemplateCompare.scrollInterval);
          }
        }, 1);
      }
    });
  },

  scrollSet(container) {
    let newScroll = TemplateCompare.scrolled;

    container.css({
      transform: `translateX(${newScroll * -1}px)`,
    });

    container.find(".compare-group-item__heading").css({
      transform: `translateX(${newScroll}px)`,
    });

    container.find(".compare-group__head").css({
      transform: `translateX(${newScroll}px)`,
    });

    $(".compare-table__header-inner").css({
      transform: `translateX(${newScroll * -1}px)`,
    });
  },

  events() {
    $(".toggle-all-accordions").on("click", function () {
      const accordions = $(this).parent().find(".accordion");

      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        accordions.removeClass("open");
        accordions.find(".accordion__content").slideUp();
      } else {
        $(this).addClass("open");
        accordions.addClass("open");
        accordions.find(".accordion__content").slideDown();
      }
    });

    $(".accordion__toggle").on("click", function () {
      $(this).parent().toggleClass("open");
      $(this).siblings(".accordion__content").slideToggle();
    });

    $(".compare-group__toggle").on("click", function () {
      $(this).toggleClass("compare-group__toggle--active");
      $(this).parent().parent().toggleClass("compare-group--open");
      $(this).parent().next().slideToggle();
    });

    $(
      ".compare-product__remove, .compare-product__add, .compare-product__top"
    ).on("click", function () {
      if (
        $(this).hasClass("compare-product__top") &&
        $(this).data("type") == "remove"
      ) {
        return;
      }
      setTimeout(function () {
        location.reload();
      }, 100);
    });

    $('[name="new-machinery-select"]').on("change", function () {
      const productId = parseInt($(this).val());
      if (productId) {
        TemplateCompare.compareAdd(productId);
        setTimeout(function () {
          location.reload();
        }, 100);
      }
    });
  },

  compareAdd(productId) {
    const compare = Cookies.get(TemplateCompare.coookieName);
    const machineryCompare = compare ? JSON.parse(compare) : [];

    if (machineryCompare.indexOf(productId) == -1) {
      machineryCompare.push(productId);
    }

    Cookies.set(TemplateCompare.coookieName, JSON.stringify(machineryCompare));
  },

  adjustMaxWidth() {
    const itemCount = $(".compare-table").data("count");
    const header = $(".compare-table__header-inner")[0];
    const head = $(".compare-table__head")[0];
    const body = $(".compare-table__body")[0];

    let base = 270;
    if (window.innerWidth < 768) {
      base = 250;
    }

    let width = base * itemCount;

    header.style.minWidth = width + "px";
    head.style.minWidth = width + "px";
    body.style.minWidth = width + "px";
  },
};
export default TemplateCompare;
